import TopicIcon from '@mui/icons-material/Topic';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import InventoryIcon from '@mui/icons-material/Inventory';
import { Dashboard } from '@mui/icons-material';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const projectsManagement = {
  id: 'projects-management',
  title: 'Gestión Proyectos',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: Dashboard,
      breadcrumbs: false
    },
    {
      id: 'projectsManagement',
      title: 'Proyectos',
      type: 'item',
      url: '/projectsManagement',
      icon: TopicIcon,
      breadcrumbs: false
    },
    {
      id: 'approvManagement',
      title: 'Aprobados',
      type: 'item',
      url: '/approveManagement',
      icon: FactCheckIcon,
      breadcrumbs: false
    },
    {
      id: 'pendingManagement',
      title: 'Pendientes',
      type: 'item',
      url: '/pendingManagement',
      icon: PendingActionsIcon,
      breadcrumbs: false
    },
    {
      id: 'rejectedManagement',
      title: 'Rechazados',
      type: 'item',
      url: '/rejectedManagement',
      icon: ThumbDownIcon,
      breadcrumbs: false
    },
    {
      id: 'archivedManagement',
      title: 'Archivado',
      type: 'item',
      url: '/archivedManagement',
      icon: InventoryIcon,
      breadcrumbs: false
    }
  ]
};

export default projectsManagement;
